export const LOCALE_PREFIX = 'scenes.Gnosus.components.EntityStack.components.StackContent.components.GroupsContent'

export const LOAD_GROUPS = 'LOAD_GROUPS'
export const GROUPS_LOADED = 'GROUPS_LOADED'
export const LOAD_GROUPS_REQUEST = 'LOAD_GROUPS_REQUEST'

export const VIRTUAL_LIST_ID = 'groups_virtual_list'
